import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Public layout for /events/* (e.g. /events/rsvp).
 * No auth required — used for guest RSVP landing pages.
 */
export const Route = createFileRoute('/events')({
  component: EventsLayout,
});

function EventsLayout() {
  return <Outlet />;
}
